import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { TrafficSplineChartForTopics } from '../../Total/TrafficSplineChartForTopics';
import { TrafficBarChartForTopics } from '../../Total/TrafficBarChartForTopics';
import { PercentTotalTrafficSplineChart } from '../../Total/PercentTotalTrafficSplineChart';
import { TrafficGridTopics } from '../../Total/TrafficGridTopics';
import { KeywordCountForTopics } from '../../Total/KeywordCountForTopics';

/**
 * Organic traffic page for topic views
 */
export function TopicOrTopicGroupPage() {
  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <TrafficSplineChartForTopics trafficType="organicTraffic" />
        <TrafficBarChartForTopics trafficType="organicTraffic" />
        <KeywordCountForTopics keywordType="organicTrafficKeywordCount" />
        <PercentTotalTrafficSplineChart trafficType="organicTraffic" />
        <TrafficGridTopics trafficType="organicTraffic" />
      </Flex>
    </BasePageContainer>
  );
}
